import gql from "graphql-tag";

const CHAPTERS_QUERY = gql`
query Chapters($lookupId: String!){
    chapters(lookupId: $lookupId) {
        LookupId
        Name
        Group
        GroupID
        GroupType
        StartDate
        EndDate
        Role
        RoleStartDate
        RoleEndDate
        Current
        Former
        PrimaryContact
        roles {
            Role
            RoleStartDate
            RoleEndDate
        }
        upcoming {
            Active
            Cancelled
            ChapterId
            ChapterName
            EventLookupId
            EventStartDate
            EventStartTime
            EventEndDate
            EventEndTime
            EventName
            EventCategory
            CancelledDate
            CancelledComment
        }
        past {
            Active
            Cancelled
            ChapterId
            ChapterName
            EventLookupId
            EventStartDate
            EventStartTime
            EventEndDate
            EventEndTime
            EventName
            EventCategory
            CancelledDate
            CancelledComment
        }
    }
}
`;

export default CHAPTERS_QUERY;